import * as React from "react";
import Typography from "@mui/material/Typography";
import { Box, styled } from "@mui/material";
import { colors } from "../../configs";
import Navbar from "../../components/navbar/Navbar";
import { Link, useLocation } from "react-router-dom";
import FareBoundSliceCard from "../../components/FareBoundSlicecard/FareBoundSliceCard";
import FareCard from "../../components/FareCard/FareCard";
import { Divider } from "@mantine/core";
import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket";
import PaymentsIcon from "@mui/icons-material/Payments";
import FilterDramaTwoToneIcon from "@mui/icons-material/FilterDramaTwoTone";
import ClearIcon from "@mui/icons-material/Clear";
import LuggageIcon from "@mui/icons-material/Luggage";
const tiers = [
  {
    title: "Free",
    price: "0",
    description: [
      "10 users included",
      "2 GB of storage",
      "Help center access",
      "Email support",
    ],
    buttonText: "Sign up for free",
    buttonVariant: "outlined",
  },
  {
    title: "Pro",
    subheader: "Most popular",
    price: "15",
    description: [
      "20 users included",
      "10 GB of storage",
      "Help center access",
      "Priority email support",
    ],
    buttonText: "Get started",
    buttonVariant: "contained",
  },
  {
    title: "Enterprise",
    price: "30",
    description: [
      "50 users included",
      "30 GB of storage",
      "Help center access",
      "Phone & email support",
    ],
    buttonText: "Contact us",
    buttonVariant: "outlined",
  },
];
const footers = [
  {
    title: "Company",
    description: ["Team", "History", "Contact us", "Locations"],
  },
  {
    title: "Features",
    description: [
      "Cool stuff",
      "Random feature",
      "Team feature",
      "Developer stuff",
      "Another one",
    ],
  },
  {
    title: "Resources",
    description: [
      "Resource",
      "Resource name",
      "Another resource",
      "Final resource",
    ],
  },
  {
    title: "Legal",
    description: ["Privacy policy", "Terms of use"],
  },
];
const FareBound = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  margin: "0px 50px 50px 0px",
});
const OptionListItem = styled(Typography)({
  fontSize: "14px",
  color: "#000000",
  fontWeight: 500,
});
const FareOptions = ({ offer }: any) => {
  return (
    <Box>
      <Box
        sx={{
          minHeight: "250px",
          backgroundColor: "#eeeeee",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignContent: "center",
          padding: "10px 30px",
          position: "relative",
        }}>
        <Typography
          variant="h4"
          component="span"
          sx={{
            color: colors.main,
            flex: 1,
            fontWeight: "bold",
          }}>
          <pre>
            <Link to="/">Teksa Corp.</Link>
          </pre>
        </Typography>
        <Navbar />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          padding: "50px",
        }}>
        {/* Fare options panel */}
        <Box sx={{ flex: 4 }}>
          <FareBound>
            <Typography variant="h5" component="code">
              Outbound
            </Typography>
            <FareBoundSliceCard />
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
              }}>
              <FareCard checked={true} />
              <FareCard checked={false} />
              <FareCard checked={false} />
              <FareCard checked={false} />
            </Box>
          </FareBound>
          <FareBound>
            <Typography variant="h5" component="code">
              InBound
            </Typography>
            <FareBoundSliceCard />
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 1,
              }}>
              <FareCard checked={true} />
              <FareCard checked={false} />
              <FareCard checked={false} />
              <FareCard checked={false} />
            </Box>
          </FareBound>
        </Box>
        {/* left price total panel */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            backgroundColor: "#F5F4F8",
            borderRadius: "3px",
            padding: "15px",
            borderWidth: "1px",
            height: "100%",
          }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}>
            <Typography variant="h6" component="code">
              Summary
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}>
            <Divider orientation="horizontal" />

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",

                gap: 0.5,
                margin: "10px 0",
              }}>
              <Typography variant="body1" component="span">
                Sold By
              </Typography>
              <img
                src={
                  "https://upload.wikimedia.org/wikipedia/commons/d/d0/Emirates_logo.svg"
                }
                alt=""
                style={{
                  width: "15px",
                  borderRadius: "50%",
                }}
              />
              <Typography variant="body1" component="span">
                Emirates Airlines
              </Typography>
            </Box>
            <Divider variant="dashed" />

            <OptionListItem variant="body1">
              <AirplaneTicketIcon fontSize="small" /> No data on changes
            </OptionListItem>
            <OptionListItem variant="body1">
              <PaymentsIcon fontSize="small" /> No data on refunds
            </OptionListItem>
            <OptionListItem variant="body1">
              <ClearIcon fontSize="small" /> No carry-on bags
            </OptionListItem>
            <OptionListItem variant="body1">
              <LuggageIcon fontSize="small" /> Included 2 checked bags
            </OptionListItem>

            <OptionListItem variant="body1">
              <FilterDramaTwoToneIcon fontSize="small" /> 742kg CO2
            </OptionListItem>

            <Divider variant="dashed" my="md" />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}>
            <Typography variant="body1">Total amount</Typography>
            <Typography variant="h6">€768.39</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default FareOptions;
